export default __webpack_public_path__ + "static/media/galerie5.41519c84.jpg";